import loader from "../stores/loader";
import error from "../stores/error";

const REQUEST_PATH = "/api/";
//const REQUEST_PATH = "/vendor/scripts/";

const errorHandler = error => {
    loader.hide();

    return [error, null];
};

const apiGet = (url, show_loader = true) => {

    if (show_loader) loader.show();

    return fetch(REQUEST_PATH + url)
        .then(async res => {
            const result = await res.json()

            loader.hide();

            if (result.error) {
                error.show(result.error);
                return [result.error, null];
            }

            return [null, result.data];
        }).catch(errorHandler);
}

const apiPost = (url, data, show_loader = true) => {

    if (show_loader) loader.show();

    return fetch(REQUEST_PATH + url, {
        method: "POST",
        body: JSON.stringify(data)
    })
        .then(async res => {
            const result = await res.json()

            loader.hide();

            if (result.error) {
                error.show(result.error);
                return [result.error, null];
            }

            return [null, result.data];
        }).catch(errorHandler);
}

const initApp = () => {
    return apiGet('initialize', false);
}

const geosLoad = () => apiGet('geos_load', true);
const geoDelete = (id) => apiPost('geo_delete', {id});
const geoSearch = (term, min_level = 0, max_level = 3) => apiPost('geo_search', {term, min_level, max_level});
const geoSave = (geo) => apiPost('geo_save', {geo});
const geosMatch = (source_id, matches, source_selected_id, geo_selected_id)  => apiPost('geos_match', { source_id, matches, source_selected_id, geo_selected_id });
const geosBackup = () => apiGet('backup', true);
const geosRestore = () => apiGet('restore', true);
const geoMark = (source_id, location_id, marked) => apiPost('geo_mark', { source_id, location_id, marked });


const kritikesImport = () => apiGet('kritikes_locations_import', true);
const kritikesLoad = () => apiGet('kritikes_load', true);
const kritikesMark = (id, is_marked) => apiPost('kritikes_mark', { id, is_marked });

const settingsSave = (agent_id, settings) => apiPost('agent_settings_save', { agent_id, settings });


const categoriesLoad = () => apiGet('categories_load', true);
const categorySave = (category) => apiPost('category_save', {category});
const categorySearch = (term) => apiPost('category_search', {term});

const attributesLoad = () => apiGet('attributes_load', true);
const attributeLoad = (id) => apiPost('attribute_load', {id});
const attributeSave = (attribute) => apiPost('attribute_save', {attribute});


// LOCALS MATCH
const localGeosLoad = () => apiGet('local_geos_load', true);
const foreignGeosLoad = (source) => apiPost('foreign_geos_load', {source});

export {
    initApp,
    geosLoad,
    geoSearch,
    geoSave,
    geoDelete,
    geosMatch,
    geosBackup,
    geosRestore,
    geoMark,

    categoriesLoad,
    categorySave,
    categorySearch,

    attributesLoad,
    attributeLoad,
    attributeSave,

    kritikesImport,
    kritikesLoad,
    kritikesMark,

    localGeosLoad,
    foreignGeosLoad,

    settingsSave,
};
